import React, { Suspense } from "react";

// module-level cache so refs stay stable across navigations (same pattern as before)
const cache = {};

function getComponent(name) {
  if (!cache[name]) {
    cache[name] = React.lazy(() => import(`./components/${name}`)); 
  }
  return cache[name];
}

export default function Lazy({ name, ...props }) {
  const Component = getComponent(name);
  return <Component {...props} />;
}